import { SidebarGroupContent } from '../components/SidebarGroup';
import {
  SidebarMenu,
  SidebarMenuItem,
  SidebarNavigationItem,
} from '../components/SidebarMenu';
import { type SideBarConfig } from '../types/Sidebar.types';

type SidebarAccountProps = {
  config: SideBarConfig;
};

export const SidebarAccount = ({ config }: SidebarAccountProps) => {
  return (
    <SidebarGroupContent>
      <SidebarMenu>
        {config.map((item) => (
          <SidebarMenuItem key={item.title}>
            <SidebarNavigationItem {...item} tooltip={item.title} />
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
    </SidebarGroupContent>
  );
};
